// components/Meta.jsx
import { useEffect } from "react";

const Meta = ({ title, description }) => {
  useEffect(() => {
    if (title) document.title = title;

    const descTag = document.querySelector('meta[name="description"]');
    if (descTag) {
      descTag.setAttribute("content", description || "");
    } else {
      const meta = document.createElement("meta");
      meta.name = "description";
      meta.content = description || "";
      document.head.appendChild(meta);
    }
  }, [title, description]);

  return null;
};

export default Meta;
